import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, category: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.CATEGORY_CREATE_REQUEST:
      return { ...INITIAL_STATE, loading: true, category: null, error: null };
    case CONST.CATEGORY_CREATE_SUCCESS:
      return { ...INITIAL_STATE, loading: false, category: action.category, error: null };
    case CONST.CATEGORY_CREATE_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error, category: null };
    case CONST.CLOSE_MODAL:
      return { ...INITIAL_STATE, loading: false, error: null, category: null };
    default:
      return state;
  }
};
